import { render, staticRenderFns } from "./CmgChipotleUExtrasHeadBanner.vue?vue&type=template&id=4bda8254&scoped=true&lang=pug"
import script from "./cmg-chipotle-u-extras-head-banner.ts?vue&type=script&lang=ts&external"
export * from "./cmg-chipotle-u-extras-head-banner.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgChipotleUExtrasHeadBanner.vue?vue&type=style&index=0&id=4bda8254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bda8254",
  null
  
)

export default component.exports